<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :url="url"
      :allowFields="$lang.searchAssessmentPlan"
      :title="$lang.searchAssessment_plan"
      :remove_item="remove_item"
      :toggleable="false"
      :toggle_item="toggle_item"
      :allowRemove="true"
      remove-modal-size="xl"
      add-modal-size="lg"
      :isImportExcel="true"
      :isImportExcelTooltip="$lang.import_assessment_sample_download"
      :dynamicButtons="availableButtons"
      :hiddenFields="hiddenFields"
      ref="assessmentPlan"
      @importExcel="importExcel"
      @getPermisson="updatePermissions"
    >
      <template slot="addModal" slot-scope="search">
        <AddAssessmentPlan
          isModal
          @modal-end-up="search.close"
          @getData="getData"
        />
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="importExcelModal"
      size="xl"
      hide-header
      hide-footer
    >
      <ShowCardUpload
        :url="assessmentUploadExcelUrl"
        :showAlert="assessmentExampleFileLink"
        @closeModal="importExcelModal = false"
        @getItems="getData"
      />
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="cloneAssessmentModal"
      size="md"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <b v-text="$lang.assessment_plan_clone" />
        </div>
        <LoadingSpinner
          :loading="cloneAssessmentLoading"
          :text="$lang.sending_data"
        />
        <b-row v-if="!cloneAssessmentLoading">
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.new_name_assessment_plan}: `"
                :rules="$v.newAssessmentName.$params"
              />
              <b-form-input
                v-model="$v.newAssessmentName.$model"
                type="text"
                autocomplete="off"
                :state="
                  $v.newAssessmentName.$dirty
                    ? !$v.newAssessmentName.$error
                    : null
                "
              />
              <b-form-invalid-feedback
                :state="
                  $v.newAssessmentName.$dirty
                    ? !$v.newAssessmentName.$error
                    : null
                "
              >
                <div v-if="!$v.newAssessmentName.required">
                  {{
                    $lang.error_required
                      | replace($lang.new_name_assessment_plan)
                  }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="text-right pt-3">
            <b-button
              variant="success"
              @click="clone"
              v-if="isAdmin(permissions)"
            >
              {{ $lang.submitButton }}
              <mdicon name="check" size="20" />
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="cloneCloneAssessmentModal"
            >
              {{ $lang.close }}
              <mdicon name="close" size="20" />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import AddAssessmentPlan from "./addAssessment_plan";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { generateApiUrl, isAdmin } from "@/shared/utils";

export default {
  name: "search-assessment-plan",
  components: {
    Search,
    AddAssessmentPlan,
    ShowCardUpload,
    LoadingSpinner,
  },
  validations: {
    newAssessmentName: { required },
  },
  data() {
    return {
      loadingItem: false,
      hiddenFields: [
        "start_time",
        "end_time",
        "time_step",
        "day_count",
        "created_by",
        "created_at",
        "room_count",
        "company",
      ],
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "assessmentPlan",
          click: this.addData,
        },
        {
          id: "2",
          name: "view",
        },
        {
          id: "7",
          name: "clone",
          tooltip: this.$lang.assessment_plan_clone,
          click: this.showCloneAssessmentModal,
        },
        {
          id: "3",
          name: "delete",
          allowAssignCenterExecute: [0],
        },
      ],
      importExcelModal: false,
      cloneAssessmentModal: false,
      cloneAssessmentLoading: false,
      newAssessmentName: null,
      currentAssessmentPlan: null,
      permissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["kanoon", "assessment_plan"]);
    },
    assessmentUploadExcelUrl() {
      return generateApiUrl(["kanoon", "import_assessment_plan_pseudo_data"]);
    },
    assessmentExampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_assessment_plan_data.xlsx`;
      return `<div class='text-center font-weight-bold'>
      <a href='${link}'>${this.$lang.download_sample_file}</a></div>`;
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    addData(item) {
      this.$router.push({
        name: "assessment_plan_pseudo_data",
        params: {
          id: item.id,
        },
      });
    },
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    toggle_item(item) {},
    getData() {
      this.$refs.assessmentPlan.getItems();
    },
    importExcel() {
      this.importExcelModal = true;
    },
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
    showCloneAssessmentModal(item) {
      this.currentAssessmentPlan = item;
      this.cloneAssessmentModal = true;
    },
    cloneCloneAssessmentModal(item) {
      this.currentAssessmentPlan = null;
      this.cloneAssessmentModal = false;
    },
    async clone() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.cloneAssessmentLoading = true;
        const id = pathOr(null, ["id"], this.currentAssessmentPlan);
        const url = generateApiUrl(["kanoon", "assessment_plan_clone"], [id]);
        const payload = {
          name: this.newAssessmentName,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.cloneCloneAssessmentModal();
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.cloneAssessmentLoading = false;
      }
    },
    availableButtons(item) {
      return this.buttons.filter((button) => {
        const allowAssignCenterExecute = pathOr(
          [],
          ["allowAssignCenterExecute"],
          button
        );
        const assignCenterExecute = pathOr(
          null,
          ["assign_center_execute"],
          item
        );
        let con = true;
        if (allowAssignCenterExecute.length) {
          con = includes(assignCenterExecute, allowAssignCenterExecute);
        }
        return con;
      });
    },
  },
};
</script>
